export enum AgentPriority {
  First = 'first',
  Normal = 'normal',
  Last = 'last',
  Supervisor = 'supervisor',
}
